import type { AuthStorage } from "./auth-storage";
import { PlatformSession } from "./platform-session";
import { api } from "./session-api";
import { VkGamesAuthAdapter } from "./vkgames-auth-adapter";
import { initializeVkGamesSdk, readVkGamesDisplayName } from "./vkgames-sdk";

type PlatformApi = Pick<typeof api, "vkGamesSession" | "session" | "profile">;

export class VkGamesSession extends PlatformSession {
  constructor(
    launchParams: string,
    storage: AuthStorage,
    requests: PlatformApi = api,
    initialize: () => Promise<void> = initializeVkGamesSdk,
    readDisplayName: () => Promise<string | undefined> = readVkGamesDisplayName,
  ) {
    super(
      new VkGamesAuthAdapter(
        launchParams,
        requests,
        initialize,
        readDisplayName,
      ),
      storage,
      requests,
    );
  }
}
